import {
  setCheckButtons,
  setTableButtons,
  setFormButtons,
  getCardFormHeadButtons
} from '@/utils/getbuttons.js'

const person = {
  person: {
    name: 'person',
    theme: '人员信息',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'cardForm',
      'collapses',
      'dialogForm',
      'dialogTable'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'person/getPersonList',
    deleteFun: 'person/purgePerson',
    getQcode: 'person/getPersonQcode',
    getDetailFun: 'person/getPersonInfo',
    headButtons: setCheckButtons([
      '新增',
      '导入人员',
      '导入银行卡',
      '导入签名',
      '批量封存',
      '批量解封'
    ]),
    selectColumn: true,
    subcomponents: [
      'identity',
      'baseInfo',
      'bankCard',
      'signature',
      'qualification',
      'experience'
    ],
    cardFormNames: ['identity', 'baseInfo'],
    collapsesNames: ['bankCard', 'signature', 'qualification', 'experience'],
    queryParams: {
      sex: '',
      mainBusiness: '',
      currentAcademic: '',
      ageUid: '',
      query: ''
    },
    selectData: [
      {
        key: 'mainBusiness',
        label: '主业工种',
        type: 'select',
        placeholder: '请搜索或输入',
        filterable: true,
        create: true,
        options: (params) => {
          return params.dictionarys.business
        }
      },
      {
        key: 'currentAcademic',
        label: '当前职称',
        type: 'select',
        placeholder: '请搜索或输入',
        filterable: true,
        create: true,
        options: (params) => {
          return params.dictionarys.academic
        }
      },
      {
        key: 'ageUid',
        label: '年龄段',
        type: 'select',
        options: (params) => {
          return params.dictionarys.ageGroup
        },
        checkByValue: true
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '姓名/身份证号/手机号码'
      },
      {
        key: 'sex',
        label: '性别',
        type: 'select',
        options: (params) => {
          return params.dictionarys.sex
        }
      }
    ],
    detailPage: [
      {
        buttonName: '新增',
        type: 'cardForm',
        name: 'person',
        theme: 'person',
        step: 'personInfo',
        label: '新增人员档案',
        pageStatus: 'adminAdd'
      },
      {
        buttonName: '编辑',
        type: 'cardForm',
        name: 'person',
        theme: 'person',
        step: 'personInfo',
        label: '编辑人员档案',
        checkType: 'checkByUid',
        checkFun: 'person/getPersonInfo'
      },
      {
        buttonName: '导入人员',
        type: 'dialogTable',
        name: 'upLoadPersonInfo'
      },
      {
        buttonName: '导入银行卡',
        type: 'dialogTable',
        name: 'upLoadBankCard'
      },
      {
        buttonName: '导入签名',
        type: 'dialogTable',
        name: 'upLoadSignature'
      }
    ],
    rowData: (params) => {
      return params.state.person.personList.result
    },
    rowTotal: (params) => {
      return params.state.person.personList.totalSize
    },
    columns: [
      { prop: 'name', label: '人员姓名', width: '', overflow: false, tooltip: { tipKey: 'formerName', tipLabel: '曾用名：' } },
      { prop: 'idCard', label: '身份证号', width: '200px' },
      {
        prop: 'sex',
        label: '性别',
        tag: (params) => {
          return params.dictionarys.sex
        }
      },
      { prop: 'age', label: '年龄', width: '' },
      { prop: 'provinceCity', label: '籍贯', width: '260px' },
      { prop: 'phoneNumber', label: '手机号码', width: '' },
      {
        prop: 'archiveStatusName',
        label: '信息状态',
        width: '100px',
        tag: [
          { label: '正常', type: 'success' },
          { label: '封存', type: 'danger' }
        ]
      },
      {
        label: '操作',
        buttons: setTableButtons([
          '编辑',
          '二维码',
          '封存',
          '解封',
          { name: '删除', code: 'purge' }
        ]),
        width: '420px'
      }
    ],
    hasPagination: true,
    identity: {
      addFun: (params) => {
        return params.theme === 'person' || params.pageStatus === 'adminAdd'
          ? 'person/addPerson'
          : 'person/upLoadPerson'
      },
      editFun: 'person/editPerson',
      addArray: (params) => {
        return params.theme !== 'person' && params.pageStatus !== 'adminAdd'
      },
      getDetailFun: 'person/getPersonBaseInfo',
      formParams: {
        name: '',
        formerName: '',
        sex: '',
        age: '',
        nation: '',
        birthday: '',
        nativePlace: '',
        idcard: '',
        address: '',
        licenceOrg: '',
        idcardFrontSluid: '',
        idcardBackSluid: '',
        faceSluid: '',
        phoneNumber: (params) => {
          if (params.pageStatus === 'adminAdd') {
            return ''
          }
          return params.theme !== 'person' && params.state.formValues.personUser
            ? params.state.formValues.personUser.telphoneNum
            : ''
        },
        fileLists: {
          faceSluid: [],
          idcardFrontSluid: [],
          idcardBackSluid: []
        }
      },
      formRules: {
        name: [
          {
            required: true,
            message: '请输入人员姓名',
            trigger: 'blur'
          }
        ],
        idcard: [
          {
            required: true,
            message: '请输入身份证号',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.validate.validateIdcard
            },
            trigger: 'blur'
          }
        ],
        phoneNumber: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur'
          },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '手机号码输入不合法',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          card: '身份信息',
          formerNameKind: 'person',
          cardTip: (params) => {
            const completing =
              params.pageStatus === 'complete' ||
              (params.state.pageStatus &&
                params.state.pageStatus.baseInfo === 'complete')
            if (completing) {
              return '提示：进场完善档案时，人员身份信息只读不可修改（手机号为空时可补填）；其他模块已有信息只读，仅缺失项可补全保存。'
            }
            if (
              params.pageStatus === 'outsideCheck' &&
              params.theme === 'builder'
            ) {
              return '提示：进场完善档案时，人员身份信息只读不可修改（手机号为空时可补填）；其他模块已有信息只读，仅缺失项可补全保存。'
            }
            return params.pageStatus === 'outsideCheck'
              ? '提示：如果该人员还未进场你的机构，个人身份、银行卡、签名等敏感信息将不可查看。'
              : ''
          },
          headButtons: getCardFormHeadButtons(0),
          fields: [
            {
              key: 'faceSluid',
              label: '个人头像照片',
              type: 'upload',
              uploadtip: '个人头像照片', // 上传提示语
              url: '/static/face/image',
              listType: 'text',
              fileType: 'face',
              showFilelist: false,
              span: 8
            },
            {
              key: 'idcardFrontSluid',
              label: '身份证头像面照片',
              type: 'upload',
              uploadtip: '点击上传“身份证头像面照片”自动识别', // 上传提示语
              listType: 'text',
              fileType: 'idCard',
              showFilelist: false,
              span: 8
            },
            {
              key: 'idcardBackSluid',
              label: '身份证国徽面照片',
              type: 'upload',
              uploadtip: '点击上传“身份证国徽面照片”自动识别', // 上传提示语
              listType: 'text',
              fileType: 'idCard',
              showFilelist: false,
              span: 8
            },
            {
              key: 'name',
              label: '姓名',
              type: 'input'
            },
            {
              key: 'sex',
              label: '性别',
              type: 'select',
              options: (params) => {
                return params.dictionarys.sex
              }
            },
            {
              key: 'age',
              label: '年龄',
              type: 'input'
            },
            {
              key: 'nation',
              label: '民族',
              type: 'select',
              filterable: true,
              options: (params) => {
                return params.dictionarys.nation
              }
            },
            {
              key: 'birthday',
              label: '出生日期',
              type: 'time'
            },
            {
              key: 'nativePlace',
              label: '籍贯',
              type: 'cascader',
              placeholder: '选择省份后，可输入关键词搜索',
              showAllLevels: false,
              filterable: true,
              emitPath: false,
              options: (params) => {
                return params.dictionarys.province
              }
            },
            {
              key: 'idcard',
              label: '身份证号',
              type: 'input'
            },
            {
              key: 'phoneNumber',
              label: '手机号码',
              type: 'input',
              placeholder: '档案联系电话；保存后同步关联登录账号手机号'
            },
            {
              key: 'licenceOrg',
              label: '发证机关',
              type: 'input'
            },
            {
              key: 'address',
              label: '家庭住址',
              type: 'input',
              span: (params) => {
                return params.pageStatus === 'add' ||
                  params.pageStatus === 'edit' ||
                  params.pageStatus === 'adminAdd' ||
                  params.pageStatus === 'complete'
                  ? 24
                  : 18
              }
            }
          ]
        }
      ]
    },
    baseInfo: {
      editFun: 'person/editPerson',
      getDetailFun: 'person/getPersonBaseInfo',
      formParams: {
        phoneNumber: '',
        emergencyContact: '',
        contactNum: '',
        beginWorkTime: '',
        currentAcademic: '',
        mainBusiness: '',
        otherBusiness: [],
        political: '群众',
        educationDegree: '高中',
        isDisease: '无重大病史',
        isJoinSocial: 'false',
        isJoinCooperative: 'true',
        isJoinUnion: '0',
        joinUnionTime: '',
        reportSlUid: [],
        fileLists: {
          reportSlUid: []
        }
      },
      formRules: {
        contactNum: [
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '手机号码输入不合法',
            trigger: 'blur'
          }
        ],
        otherBusiness: [
          {
            validator: (params) => {
              return params.validate.validateOtherBusiness
            },
            type: 'array',
            trigger: 'change'
          }
        ],
        isJoinSocial: [
          {
            validator: (params) => {
              return params.validate.validateSocial
            },
            trigger: 'change'
          }
        ],
        isJoinCooperative: [
          {
            validator: (params) => {
              return params.validate.validateCooperative
            },
            trigger: 'change'
          }
        ]
      },
      formData: [
        {
          card: '基础信息',
          cardTip: (params) => {
            if (params.pageStatus === 'complete') {
              return '提示：已有信息只读显示；仅缺失项可补全后保存。手机号码请在「身份信息」中维护（若为空可在身份信息补填）。职称、工种为选填，其他可从业工种最多选择5种'
            }
            return params.pageStatus === 'add' ||
              params.pageStatus === 'edit' ||
              params.pageStatus === 'adminAdd'
              ? '提示：手机号码请在「身份信息」中维护。职称、工种为选填，其他可从业工种最多选择5种'
              : ''
          },
          manualUpload: true,
          headButtons: getCardFormHeadButtons(1),
          fields: [
            {
              key: 'emergencyContact',
              label: '紧急联系人',
              type: 'input'
            },
            {
              key: 'contactNum',
              label: '紧急联系人电话',
              type: 'input'
            },
            {
              key: 'beginWorkTime',
              label: '开始工作时间',
              type: 'time'
            },
            {
              key: 'currentAcademic',
              label: '当前职称',
              type: 'select',
              options: (params) => {
                return params.dictionarys.academic
              }
            },
            {
              key: 'mainBusiness',
              label: '主业工种',
              type: 'select',
              placeholder: '请搜索选择',
              filterable: true,
              options: (params) => {
                return params.dictionarys.business
              }
            },
            {
              key: (params) => {
                return params.pageStatus === 'add' ||
                  params.pageStatus === 'edit' ||
                  params.pageStatus === 'adminAdd' ||
                  params.pageStatus === 'complete'
                  ? 'otherBusiness'
                  : 'otherBusinessName'
              },
              label: '其他可从业工种',
              type: 'select',
              placeholder: '请搜索或输入，最多五项',
              multiple: true,
              filterable: true,
              create: true,
              options: (params) => {
                return params.dictionarys.business
              },
              span: (params) => {
                return params.pageStatus === 'add' ||
                  params.pageStatus === 'edit' ||
                  params.pageStatus === 'adminAdd' ||
                  params.pageStatus === 'complete'
                  ? 16
                  : 12
              }
            },
            {
              key: 'political',
              label: '政治面貌',
              type: 'select',
              options: (params) => {
                return params.dictionarys.political
              }
            },
            {
              key: 'educationDegree',
              label: '文化程度',
              type: 'select',
              options: (params) => {
                return params.dictionarys.educationDegree
              }
            },
            {
              key: 'isDisease',
              label: '是否有重大病史',
              type: 'select',
              placeholder: '请搜索或输入',
              filterable: true,
              create: true,
              options: (params) => {
                return params.dictionarys.isDisease
              }
            },
            {
              key: (params) => {
                return params.pageStatus === 'add' ||
                  params.pageStatus === 'edit' ||
                  params.pageStatus === 'complete'
                  ? 'isJoinSocial'
                  : 'joinSocial'
              },
              label: '是否参加社保',
              type: 'select',
              options: (params) => {
                return params.dictionarys.isTrue
              },
              checkByValue: true
            },
            {
              key: (params) => {
                return params.pageStatus === 'add' ||
                  params.pageStatus === 'edit' ||
                  params.pageStatus === 'complete'
                  ? 'isJoinCooperative'
                  : 'joinCooperative'
              },
              label: '是否有合作医疗',
              type: 'select',
              options: (params) => {
                return params.dictionarys.isTrue
              },
              checkByValue: true
            },
            {
              key: (params) => {
                return params.pageStatus === 'add' ||
                  params.pageStatus === 'edit' ||
                  params.pageStatus === 'complete'
                  ? 'isJoinUnion'
                  : 'joinUnion'
              },
              label: '是否加入工会',
              type: 'select',
              options: (params) => {
                return params.dictionarys.isFalse
              },
              checkByValue: true
            },
            {
              key: 'joinUnionTime',
              label: '加入工会时间',
              type: 'time',
              disabled: (params) => {
                return (
                  !params.formValues || params.formValues.isJoinUnion === '0'
                )
              }
            },
            {
              key: 'reportSlUid',
              label: '体检报告',
              type: 'upload',
              uploadtip: (params) => {
                return params.pageStatus === 'add' ||
                  params.pageStatus === 'edit' ||
                  params.pageStatus === 'complete'
                  ? '只能添加jpg/png图片文件'
                  : params.pageStatus === 'outsideCheck'
                  ? '暂无权限查看该信息'
                  : params.formValues &&
                    params.formValues.fileLists &&
                    params.formValues.fileLists.reportSlUid.length
                  ? '点击图片名称可预览查看图片详情'
                  : '/'
              }, // 上传提示语
              listType: 'text',
              autoUpload: false,
              span: 24
            }
          ]
        }
      ]
    },
    bankCard: {
      name: 'bankCard',
      outsideCheck: (params) => {
        return params.pageStatus !== 'outsideCheck'
      },
      card: '银行卡',
      modifiable: true,
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增银行卡'
          : params.pageStatus === 'edit'
          ? '编辑银行卡'
          : ''
      },
      addFun: 'person/addPersonBankCard',
      editFun: 'person/editPersonBankCard',
      detailPage: [
        {
          buttonName: '新增',
          type: 'dialogForm',
          name: 'bankCard'
        },
        {
          buttonName: '编辑',
          type: 'dialogForm',
          name: 'bankCard',
          checkType: 'useRowData'
        }
      ],
      headButtons: setFormButtons(['新增']),
      deleteFun: 'person/deletePersonBankCard',
      getListFun: (params) => {
        return params.step === 'personInfo'
          ? 'person/getPersonBankCard'
          : 'person/getBackCard'
      },
      collapsesTitleImg: '#icon--',
      collapsesTitle: [{ key: 'titleText', type: 'text' }],
      collapsesList: (params) => {
        return params.state.person.bankCard
      },
      collapsesData: [
        {
          key: 'bankName',
          label: '银行名称',
          collapseType: 'text',
          collapseSpan: 8
        },
        {
          key: 'cardNum',
          label: '银行卡号',
          collapseType: 'text',
          collapseSpan: 8
        },
        {
          key: 'positivePhoto',
          label: '银行卡照片',
          collapseType: 'popover',
          collapseSpan: 8
        },
        {
          key: 'useProject',
          label: '使用项目',
          collapseType: 'tooltip',
          collapseSpan: 24
        }
      ],
      formParams: {
        uid: '',
        personUid: (params) => {
          const formName = params.state.currentStep.step.slice(0, -4)
          return formName === 'person'
            ? params.state.currentUids.person
            : params.state.formValues[formName].personUid
        },
        positivePhoto: '',
        bankName: '',
        cardNum: '',
        fileLists: {
          positivePhoto: []
        }
      },
      formRules: {
        bankName: [
          {
            required: true,
            message: '请输入银行名称',
            trigger: 'blur'
          }
        ],
        cardNum: [
          {
            required: true,
            message: '请输入银行卡号',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'bankName',
          label: '银行名称',
          type: 'input',
          span: 18
        },
        {
          key: 'cardNum',
          label: '银行卡号',
          type: 'input',
          span: 18
        },
        {
          key: 'positivePhoto',
          label: '银行卡照片',
          type: 'upload',
          uploadtip: '点击上传“银行卡正面照片”自动识别信息', // 上传提示语
          listType: 'text',
          fileType: 'backCard',
          showFilelist: false,
          span: 18
        }
      ]
    },
    signature: {
      name: 'signature',
      outsideCheck: (params) => {
        return params.pageStatus !== 'outsideCheck'
      },
      card: '电子签名',
      manualUpload: true,
      modifiable: true,
      title: (params) => {
        return params.pageStatus === 'add' ? '新增个人签名' : ''
      },
      detailPage: [
        {
          buttonName: '新增',
          type: 'dialogForm',
          name: 'signature'
        },
        {
          buttonName: '编辑',
          type: 'dialogForm',
          name: 'signature',
          checkType: 'useRowData'
        }
      ],
      headButtons: setFormButtons(['新增']),
      addFun: 'person/addPersonSignature',
      deleteFun: 'person/deletePersonSignature',
      getListFun: 'person/getPersonSignature',
      collapsesTitleImg: '#icon-dianziqianming',
      collapsesTitle: [
        { key: 'signatureName', type: 'text' },
        { key: 'titleImage', type: 'img' }
      ],
      collapsesList: (params) => {
        return params.state.person.signature
      },
      collapsesData: [
        {
          key: 'projectName',
          label: '有效项目',
          collapseType: 'tooltip',
          collapseSpan: 24
        },
        {
          key: 'validCondition',
          label: '有效条件',
          collapseType: 'text',
          collapseSpan: 24
        }
      ],
      formParams: {
        personUid: (params) => {
          const formName = params.state.currentStep.step.slice(0, -4)
          return formName === 'person'
            ? params.state.currentUids.person
            : params.state.formValues[formName].personUid
        },
        signatureName: (params) => {
          const formName = params.state.currentStep.step.slice(0, -4)
          return (
            (formName === 'person'
              ? params.state.formValues.identity.name
              : params.state.formValues[formName].personName) +
            new Date().getTime()
          )
        },
        signatureUid: '',
        fileLists: {
          signatureUid: []
        }
      },
      formRules: {
        signatureUid: [
          {
            required: true,
            message: '请上传签名图片',
            trigger: 'blur'
          }
        ],
        signatureName: [
          {
            required: true,
            message: '请输入签名名称',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.validate.validateElectorName
            },
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'signatureName',
          label: '签名名称',
          type: 'input',
          span: 18
        },
        {
          key: 'signatureUid',
          label: '签名照片',
          type: 'upload',
          uploadtip: '+  点击上传“电子签名图片”', // 上传提示语
          listType: 'text',
          fileType: 'signature',
          url: '/static/files/signature',
          autoUpload: false,
          showFilelist: false,
          span: 18
        },
        {
          type: 'button',
          isShow: (params) => {
            return params.userName === 'dpnadmin'
          },
          buttons: setFormButtons(['生成签名']),
          span: 18
        }
      ]
    },
    qualification: {
      name: 'qualification',
      card: '资格证书',
      manualUpload: true,
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增资格证书'
          : params.pageStatus === 'edit'
          ? '编辑资格证书'
          : ''
      },
      modifiable: true,
      detailPage: [
        {
          buttonName: '新增',
          type: 'dialogForm',
          name: 'qualification'
        },
        {
          buttonName: '编辑',
          type: 'dialogForm',
          name: 'qualification',
          checkType: 'useRowData'
        }
      ],
      headButtons: setFormButtons(['新增']),
      addFun: 'person/addPersonQualification',
      editFun: 'person/editPersonQualification',
      deleteFun: 'person/deletePersonQualification',
      getListFun: 'person/getPersonQualification',
      collapsesTitleImg: '#icon-tubiaozhizuomoban-',
      collapsesTitle: [
        { key: 'certificateName', type: 'text' },
        { key: 'typeIcon', type: 'icon' },
        { key: 'status', type: 'text' }
      ],
      collapsesList: (params) => {
        return params.state.person.qualification
      },
      collapsesData: [
        {
          key: 'certificateName',
          label: '证书名称',
          collapseType: 'text'
        },
        {
          key: 'certificateType',
          label: '证书类型',
          collapseType: 'text'
        },
        {
          key: 'proClassification',
          label: '专业分类',
          collapseType: 'text'
        },
        {
          key: 'workType',
          label: '类别工种',
          collapseType: 'text',
          collapseSpan: 4
        },
        {
          key: 'certificateLevel',
          label: '证书等级',
          collapseType: 'text',
          collapseSpan: 5
        },
        {
          key: 'certificateBegdate',
          label: '有效起始日期',
          collapseType: 'text'
        },
        {
          key: 'certificateEndate',
          label: '有效截止日期',
          collapseType: 'text'
        },
        {
          key: 'licensingOrg',
          label: '发证机关',
          collapseType: 'text'
        },
        {
          key: 'licensingDate',
          label: '发证日期',
          collapseType: 'text',
          collapseSpan: 4
        },
        {
          key: 'certificateStatus',
          label: '资格状态',
          collapseType: 'text',
          collapseSpan: 5
        },
        {
          key: 'licensingSjuid',
          label: '证书照片',
          collapseType: 'popover'
        }
      ],
      formParams: {
        uid: '',
        personUid: (params) => {
          return params.state.currentUids.person
        },
        certificateName: '',
        certificateType: '',
        proClassification: '',
        workType: '',
        certificateLevel: '',
        certificateBegdate: '',
        certificateEndate: '',
        licensingOrg: '',
        licensingDate: '',
        certificateStatus: '',
        licensingSjuid: '',
        fileLists: {
          licensingSjuid: []
        }
      },
      formRules: {
        certificateName: [
          {
            required: true,
            message: '请输入证书名称',
            trigger: 'blur'
          }
        ],
        certificateType: [
          {
            required: true,
            message: '请选择证书类型',
            trigger: 'blur'
          }
        ],
        certificateStatus: [
          {
            required: true,
            message: '请选择资格状态',
            trigger: 'blur'
          }
        ],
        licensingSjuid: [
          {
            required: true,
            message: '请上传证书图片',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'certificateName',
          label: '证书名称',
          type: 'input'
        },
        {
          key: 'certificateType',
          label: '证书类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.qualificationType
          },
          filterable: true
        },
        {
          key: 'proClassification',
          label: '专业分类',
          type: 'cascader',
          options: (params) => {
            return params.dictionarys.proClassification
          },
          filterable: true,
          emitPath: false
        },
        {
          key: 'workType',
          label: '类别工种',
          type: 'cascader',
          options: (params) => {
            return params.dictionarys.workType
          },
          filterable: true,
          emitPath: false
        },
        {
          key: 'certificateLevel',
          label: '证书等级',
          type: 'cascader',
          options: (params) => {
            return params.dictionarys.certificateLevel
          },
          filterable: true,
          emitPath: false
        },
        {
          key: 'certificateBegdate',
          label: '有效起始日期',
          type: 'time'
        },
        {
          key: 'certificateEndate',
          label: '有效截止日期',
          type: 'time'
        },
        {
          key: 'licensingOrg',
          label: '发证机关',
          type: 'input'
        },
        {
          key: 'licensingDate',
          label: '发证日期',
          type: 'time'
        },
        {
          key: 'certificateStatus',
          label: '资格状态',
          type: 'select',
          options: (params) => {
            return params.dictionarys.cerStatus
          }
        },
        {
          key: 'licensingSjuid',
          label: '证书照片',
          type: 'upload',
          autoUpload: false,
          limit: 1,
          span: 24
        }
      ]
    },
    experience: {
      name: 'experience',
      outsideCheck: (params) => {
        return params.pageStatus !== 'add'
      },
      card: '项目履历',
      collapsesTitleImg: '#icon-gongzuojingyan',
      collapsesTitle: [
        { key: 'titleText', type: 'text' },
        { key: 'typeIcon', type: 'icon' },
        { key: 'status', type: 'text' }
      ],
      collapsesList: (params) => {
        return params.state.person.experience
      },
      collapsesData: [
        {
          key: 'vProjectName',
          label: '项目名称',
          collapseType: 'tooltip'
        },
        {
          key: 'laborTeamName',
          label: '所属参建单位',
          collapseType: 'tooltip'
        },
        {
          key: 'walkinDate',
          label: '进场日期',
          collapseType: 'text'
        },
        {
          key: 'walkoffDate',
          label: '退场日期',
          collapseType: 'text'
        },
        {
          key: 'isForeman',
          label: '参建角色',
          collapseType: 'text'
        },
        {
          key: 'jobTitle',
          label: '岗位职务',
          collapseType: 'text'
        },
        {
          key: 'business',
          label: '从业工种',
          collapseType: 'text'
        },
        {
          key: 'totalLock',
          label: '累计出勤率',
          collapseType: 'text'
        },
        {
          key: 'evaluation',
          label: '个人考评',
          collapseType: 'text'
        }
      ]
    },
    upLoadPersonInfo: {
      title: '导入人员档案',
      name: 'upLoadPersonInfo',
      upload: true,
      rowKey: 'index',
      upLoadFun: 'person/upLoadPerson',
      getParentFun: 'person/getPersonList',
      columns: [
        { prop: 'name', label: '人员姓名', width: '100px' },
        { prop: 'phoneNumber', label: '手机号码', width: '' },
        { prop: 'idcard', label: '身份证号', width: '' },
        { prop: 'status', label: '数据状态', width: '200px' },
        {
          label: '操作',
          buttons: setTableButtons(['删除']),
          width: '80px'
        }
      ]
    },
    upLoadBankCard: {
      title: '导入银行卡',
      name: 'upLoadBankCard',
      upload: true,
      rowKey: 'index',
      upLoadFun: 'person/upLoadBankCard',
      getParentFun: 'person/getPersonList',
      columns: [
        { prop: 'name', label: '人员姓名', width: '100px' },
        { prop: 'idcard', label: '身份证号', width: '' },
        { prop: 'bankName', label: '银行名称', width: '' },
        { prop: 'cardNum', label: '银行卡号', width: '' },
        { prop: 'status', label: '数据状态', width: '200px' },
        {
          label: '操作',
          buttons: setTableButtons(['删除']),
          width: '80px'
        }
      ]
    },
    upLoadSignature: {
      title: '导入签名',
      name: 'upLoadSignature',
      upload: true,
      rowKey: 'index',
      headButtons: setCheckButtons(['重新生成', '上传图片']),
      selectColumn: true,
      upLoadFun: 'person/upLoadSignature',
      getParentFun: 'person/getPersonList',
      columns: [
        { prop: 'name', label: '人员姓名', width: '100px' },
        { prop: 'idcard', label: '身份证号', width: '' },
        { prop: 'signatureName', label: '签名名称', width: '' },
        { prop: 'status', label: '签名状态', width: '200px' },
        { prop: 'signature', label: '签名图片', width: '120px', picture: true },
        {
          label: '操作',
          buttons: setTableButtons(['删除']),
          width: '80px'
        }
      ],
      pictures: [{ prop: 'signature', label: '签名图片', width: '' }]
    }
  }
}

export default person
